<div class="row mt-3 mb-4">
  <app-banner
    [type]="BannerType.info"
    [closeable]="true"
    [message]="'conformance_report_missing_standard_banner_info' | translate"
    [isHtml]="true"
    
  ></app-banner>
</div>

<form [formGroup]="form">
  <div class="row mb-4">
    <div class="col-12">
      <ds-checkbox-group
        [label]="'accessibility_standard' | translate"
        [formControlName]="FormFields.evaluationStandards"
        [required]="true"
        [errorMessage]="evaluationStandardsError$ | async"
        [errorState]="(evaluationStandardsError$ | async)?.length > 0"
        
      >
        @for (standard of config?.mainStandardsChoice; track trackByStandard($index, standard)) {
          <ds-checkbox
            (valueChange)="standardClicked($event, standard)"
            [value]="standard"
            [label]="EVALUATION_STANDARD_TO_AUDIT_STANDARD[standard] | translate"
          ></ds-checkbox>
        }
      </ds-checkbox-group>
    </div>
  </div>

  @if (isWcagSelected) {
    <div class="row mb-4">
      <div class="col-12">
        <ds-input
          [label]="'wcag_standard' | translate"
          [required]="true"
          [errorMessage]="wcagStandardsError$ | async"
          [errorState]="(wcagStandardsError$ | async)?.length > 0"
          
          class="ms-3 ps-4"
        >
          <select ds-input-field [formControlName]="FormFields.wcagStandard">
            <option [ngValue]="null" disabled>{{ 'select_an_option' | translate }}</option>
            @for (standard of config?.wcagStandardConformanceLevels; track trackByStandard($index, standard)) {
              <option [value]="standard">
                {{ getConformanceTranslationKey(standard) | translate }}
              </option>
            }
          </select>
        </ds-input>
      </div>
    </div>
  }
</form>

<div class="row mb-4">
  <div class="col-auto">
    <button class="btn btn-primary"  (click)="onSaveStandardsForm()">
      {{ 'form_save' | translate }}
    </button>
  </div>
</div>
